import { TypeFiesta, TypeInsignia } from '@at/design-system-foundation'
import { Button } from '@at/design-system-elements'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { ErrorBox } from '../../components/search-pagination/components/error-box/error-box'
import {
    StyledSearchListingsLimitReached,
    StyledSearchListingsLoadingContent,
    StyledSearchListingsLoadingOverlay,
} from './search-listings-messages.styles'
import { Banner } from '@at/design-system-patterns'

export const SearchListingsError = () => (
    <StyledSearchListingsLoadingOverlay>
        <StyledSearchListingsLoadingContent>
            <TypeFiesta as="p">Sorry there was an error loading your search results...</TypeFiesta>
            <Button
                text="Refresh page"
                onInteraction={() => {
                    window.location.reload()
                    return
                }}
            />
        </StyledSearchListingsLoadingContent>
    </StyledSearchListingsLoadingOverlay>
)

export const SearchListingsMaximumResults = () => (
    <StyledSearchListingsLimitReached as="p">
        Maximum displayed results reached - Please refine your search to see different results.
    </StyledSearchListingsLimitReached>
)

export const SearchListingsExpiredResults = () => (
    <Banner type="in-panel" variation="warning">
        <TypeFiesta as="p">
            The advert you are looking for is no longer available but we’ve found some similar vehicles for sale that
            match your search criteria
        </TypeFiesta>
    </Banner>
)

export const EndPagination = () => {
    const history = useHistory()
    return (
        <ErrorBox dataTestid="end-pagination-message">
            <TypeInsignia as="h3">Maximum displayed results reached</TypeInsignia>
            <TypeInsignia as="p">Please refine your search to see different results.</TypeInsignia>
            <Button displayType="secondary" text={'Back to last page'} onInteraction={() => history.goBack()} />
        </ErrorBox>
    )
}
